import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=d3bd4002&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=d3bd4002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bd4002",
  null
  
)

export default component.exports